import { render, staticRenderFns } from "./showRecMsg.vue?vue&type=template&id=94d3da72&scoped=true&"
import script from "./showRecMsg.vue?vue&type=script&lang=js&"
export * from "./showRecMsg.vue?vue&type=script&lang=js&"
import style0 from "./showRecMsg.vue?vue&type=style&index=0&id=94d3da72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d3da72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94d3da72')) {
      api.createRecord('94d3da72', component.options)
    } else {
      api.reload('94d3da72', component.options)
    }
    module.hot.accept("./showRecMsg.vue?vue&type=template&id=94d3da72&scoped=true&", function () {
      api.rerender('94d3da72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/showRecMsg.vue"
export default component.exports